module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/design-tile-images/design-tile-06-f67a148bc5d43c186c0b784302357b41.jpg";